import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import NavJudul from 'components/componentsmall/nav_judul'
import {Link, useHistory} from 'react-router-dom'
import './style.css'

export default function Kode_referal() {
    const history = useHistory()
    return (
        <Container className="page-referal-code">
            <NavJudul />
            <Row>
                <Col>
                    <div className="form-referral">
                        <div className="title">
                            <Link to="/signup"><img src="asset/home/icons/back.svg" alt="back" /></Link>
                            <h3>Masukkan Kode Referral</h3>
                        </div>
                        <div className="form-group-input">
                            <p>Kodde Referral  <img src="asset/home/icons/Group.svg" alt="?" /></p>
                            <input type="text" name="referral" id="id_referral" placeholder="Kode referral anda" />
                        </div>
                        <div className="form-buttons">
                            <button onClick={_ => history.push('/login')} type="button">Lewati</button>
                            <button onClick={_ => history.push('/login')} type="button">Masuk</button>
                        </div>
                    </div>
                </Col>
                <Col>
                    <div className="referal-img">
                        <img src="asset/home/img-daftar.png" alt="daftar" />
                        <p className="text-img">Menjadi Reseller lebih mudah dengan menggunakan <span>Malmora</span></p>
                    </div>
                </Col>
            </Row>
            <br /><br /><br />
            <div className="text-span">
                2020 Malmora
            </div>
        </Container>
    )
}
